var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1644 6.02779L3.66438 2.02779C3.589 2.00155 3.50844 1.99374 3.42943 2.00501C3.35042 2.01627 3.27525 2.04628 3.21022 2.09254C3.14518 2.13879 3.09216 2.19995 3.05558 2.27088C3.01901 2.34182 2.99995 2.42048 3 2.50029V13.5003C3 13.6329 3.05268 13.7601 3.14645 13.8538C3.24021 13.9476 3.36739 14.0003 3.5 14.0003C3.63261 14.0003 3.75979 13.9476 3.85355 13.8538C3.94732 13.7601 4 13.6329 4 13.5003V10.8559L15.1644 6.97279C15.2626 6.93879 15.3478 6.87501 15.4081 6.79032C15.4684 6.70563 15.5008 6.60426 15.5008 6.50029C15.5008 6.39633 15.4684 6.29495 15.4081 6.21026C15.3478 6.12558 15.2626 6.0618 15.1644 6.02779Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.79717V3.20342L13.4781 6.50029L4 9.79717Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIconFilled);
export default __webpack_public_path__ + "static/media/flag-icon-filled.2b94817441b18aa2f09169f701d54a8a.svg";
export { ForwardRef as ReactComponent };